<template>
    <div dusk="looker-embed">
        <iframe scrolling="no" ref="iframe" :style="{ width: '100%', height }" :src="embedUrl"></iframe>
    </div>
</template>

<style>
    iframe {
        border: none;
    }

</style>

<script>
export default {
    props: {
        embedUrl: String,
        initialHeight: {
            type: String,
            default: '450px'
        }
    },

    data() {
        return {
            measuredHeight: null,
            iframeInitialized: false,
            iframeComplete: false,
            iframeCompletePayload: null
        }
    },

    mounted() {
        window.addEventListener("message", event => {
            if (event.source === this.$refs.iframe.contentWindow) {
                const data = JSON.parse(event.data);

                // Dusk tests rely on these data properties to test looker
                // is behaving properly.
                if (data.type === "dashboard:run:start") {
                    this.iframeInitialized = true;
                } else if (data.type === "dashboard:run:complete") {
                    this.iframeComplete = true;
                    this.iframeCompletePayload = data.dashboard;
                } else if (data.type === "page:properties:changed") {
                    this.measuredHeight = data.height;
                }
            }
        });
    },

    computed: {
        height() {
            if (this.measuredHeight) {
                return this.measuredHeight + 'px';
            }

            return this.initialHeight;
        }
    }
}
</script>
